import { Button } from 'components';
import { useDeveloperLogsDownload } from 'providers/IntegrationsProvider/useDeveloperLogsDownload';
import { useState } from 'react';
import { connect } from 'react-redux';
import { downloadFile } from 'utils/downloadFile';

const DownloadLogs = ({ filters }) => {
  const [downloadDisabled, setDownloadDisabled] = useState(false);
  const { mutateAsync: developerLogsDownload } = useDeveloperLogsDownload({});

  const onDownloadLogs = async () => {
    setDownloadDisabled(true);
    const response = await developerLogsDownload(filters);
    if (response?.downloadId) {
      downloadFile(`/downloads/${response.downloadId}`);
    }
    setDownloadDisabled(false);
  };

  return (
    <div className="pull-right mt-6 pb-6 ">
      <Button onClick={onDownloadLogs} className="w-full" disabled={downloadDisabled}>
        Download CSV
      </Button>
    </div>
  );
};

export default connect(({ filters }) => ({ filters }), {})(DownloadLogs);
